import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const BackgroundContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: -1,
  background: `
    linear-gradient(135deg, rgba(255,255,255,0.97) 0%, rgba(245,245,245,0.95) 100%),
    radial-gradient(circle at 0% 0%, rgba(212,175,55,0.1) 0%, rgba(255,255,255,0) 50%),
    radial-gradient(circle at 100% 100%, rgba(212,175,55,0.1) 0%, rgba(255,255,255,0) 50%)
  `,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `
      repeating-linear-gradient(45deg, 
        rgba(212,175,55,0.03) 0%, 
        rgba(212,175,55,0.03) 1px, 
        transparent 1px, 
        transparent 15px
      ),
      repeating-linear-gradient(-45deg, 
        rgba(212,175,55,0.03) 0%, 
        rgba(212,175,55,0.03) 1px, 
        transparent 1px, 
        transparent 15px
      )
    `,
  }
}));

const ContentContainer = styled(Box)({
  position: 'relative',
  minHeight: '100vh',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  '@media (max-width: 600px)': {
    minHeight: '-webkit-fill-available', // Poprawka dla iOS
  }
});

const BackgroundLayout = ({ children }) => {
  return (
    <ContentContainer>
      <BackgroundContainer />
      {children}
    </ContentContainer>
  );
};

export default BackgroundLayout;
